import $ from "jquery";
import {debounce} from "lodash"

export default {
    data() {
        return {
            shareMenuOpen: false,
            hoverSubMenuShare:false
        };
    },
    methods: {
        enterShare() {
            this.shareMenuOpen = true
        },
        leaveShare: debounce(function () {
            if (this.hoverSubMenuShare === false) {
                this.shareMenuOpen = false
            }
        }, 300),
        sharePopup(href, title, intWidth, intHeight, blnResize) {
            // Prevent default anchor event
            //event.preventDefault()
            // Set values for window
            intWidth = intWidth || "500"
            intHeight = intHeight || "400"
            title = title || "Social Share"
            var strResize = (blnResize ? "yes" : "no")
            // Set title and open popup with focus on it
            var strParam = "width=" + intWidth + ",height=" + intHeight + ",resizable=" + strResize,
                objWindow = window.open(href, title, strParam).focus()
        },
        shareMail(siteName, title, desc = "description", url = document.location.href) {


            window.location.href = `mailto:email@destinataire?subject=[ ${encodeURIComponent(siteName)} ] - ${encodeURIComponent(title)}&body=${encodeURIComponent(url)}<br><br>${encodeURIComponent(desc)}`;

        }

    },
    mounted() {
    }
};